import { KeyTextField } from '@prismicio/client';
import { ChartData } from '@/types';
import { screenSizes } from '@/constants';
import { useScreenSize } from '@/hooks';
import styles from './value.module.scss';

interface ValueProps extends Pick<ChartData, 'value' | 'unit'> {
  isFirstTab: boolean;
}

const getUnitText = (unit: KeyTextField, screenSize: { width: number }) => {
  return screenSize.width < screenSizes.desktop ? unit?.charAt(0) : `${unit}`;
};

export const Value = ({ unit, value, isFirstTab }: ValueProps) => {
  const screenSize = useScreenSize();

  return (
    <div className={styles.wrapper}>
      <div className={styles.value_container}>
        <div className={`${styles.values} ${isFirstTab ? '' : styles.second}`}>
          <span className={styles.value}>
            ${value.credit}
            {getUnitText(unit.credit, screenSize)}
          </span>
          <span className={styles.value}>
            ${value.income}
            {getUnitText(unit.income, screenSize)}
          </span>
        </div>
      </div>
    </div>
  );
};
